export function getCurrentPath(): string {
	return window.location.pathname
}
